import React from 'react'
import { ConfigurableText } from '@/app/components'
import { Icon, Text } from '@/components'
import { capitalize } from '@/utils/stringUtilities'
import { IconNames } from '@/components/Icon/Icon'

export const CollapsibleListItemHeader = ({
  status,
  title,
  rightElement,
}: {
  status: 'success' | 'failure' | 'warning' | 'unknown'
  title: string
  rightElement?: React.ReactNode
}) => {
  return (
    <div className="flex flex-row items-center justify-between gap-2 w-full">
      <div className="flex flex-row items-center gap-2 overflow-hidden flex-1 min-w-0">
        <StatusIcon status={status} className="flex-shrink-0" />
        <div className="max-w-full overflow-hidden w-full">
          <ConfigurableText className="text-themed-base-900 overflow-hidden text-ellipsis whitespace-nowrap w-full block">
            {title}
          </ConfigurableText>
        </div>
      </div>
      <div className="flex-shrink-0 h-7 flex justify-end items-center">
        {rightElement}
      </div>
    </div>
  )
}

const StatusIcon = ({
  status,
  className = '',
}: {
  status: 'success' | 'failure' | 'warning' | 'unknown'
  className?: string
}) => {
  const backgroundColor = {
    success: 'bg-themed-success',
    failure: 'bg-themed-error',
    unknown: 'bg-themed-unknown',
    warning: 'bg-themed-warning',
  }[status]

  const iconName = {
    success: 'Check' as IconNames,
    failure: 'X' as IconNames,
    warning: 'AlertTriangle' as IconNames,
  }

  if (status === 'warning') {
    return (
      <Icon
        name={iconName[status]}
        color={'white'}
        fill={'#FB8542'}
        size={24}
      />
    )
  }

  return (
    <div
      className={`rounded-full flex-none w-[16px] h-[16px] flex items-center justify-center ${backgroundColor} ${className}`}
    >
      {(status === 'success' || status === 'failure') && (
        <Icon
          name={iconName[status]}
          size={12}
          className="text-themed-base-100"
          aria-label={capitalize(status)}
        />
      )}
      {status === 'unknown' && (
        <Text variant="body3" className="text-themed-base-100 font-light">
          ?
        </Text>
      )}
    </div>
  )
}
